import { DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '.ag-theme-iris',
  standalone: false,
})
export class AgGridCommonStylesDirective {
  private readonly host = inject(ElementRef);
  private readonly agGrid = inject(AgGridAngular);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.agGrid.gridReady.pipe(
      tap(() => this.agGrid.api.setGridOption('enableCellTextSelection', true)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();

    this.agGrid.rowDataUpdated.pipe(
      tap((rowDataUpdatedEvent) => {
        const gridContainer: HTMLElement = this.host.nativeElement;
        const rowCount = rowDataUpdatedEvent.api.getRenderedNodes().length;
        const pinnedBottomRowCount = rowDataUpdatedEvent.api.getPinnedBottomRowCount();

        gridContainer.classList.toggle('ag-has-no-rows',rowCount == 0);
        gridContainer.classList.toggle('ag-has-bottom-row',pinnedBottomRowCount > 0);
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }
}
